/*
 * API
 * 项目不用分运行环境，所以oDomains里也不用分环境
 * */


const oDomains = {
  base:  'DOP_API_URL',
};

const httAddress = {
  // base: '', // 配置此地址，该服务就会直接用此地址,一般用于本地联调
}

// ajax default
let ajaxCtx = {};
for (let _key in oDomains) {
  let curHttp = '';
  if (httAddress[_key]) {
    curHttp = httAddress[_key];
  } else {
    curHttp = window.ENV_API[oDomains[_key]];
  }
  ajaxCtx[_key] = curHttp;
}
console.log(ajaxCtx);
export {ajaxCtx};


// 自定义接口调用超时时间
export const onlineOutTime = 30 * 60 * 1000;
